import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../services/axiosInstance";
import { API_ENDPOINTS } from "../services/api/apiConfig";

export const useUserAccount = (id: number | string | undefined) => {
    return useQuery<any>({
        queryKey: ['user', id],
        queryFn: async () => {
            if (!id) throw new Error("User ID is required");
            const response = await axiosInstance.get(API_ENDPOINTS.ADMINS.GET_BY_ID(Number(id)));
            return response.data;
        },
        enabled: !!id,
    });
};
